import React from 'react';
import PropTypes from 'prop-types';

import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableRow
} from '@mui/material';

import {
  dataHxContainerSx,
  dataHxDateCellSx,
  dataHxRowSx,
  dataHxTableSx
} from './styles';

const recapRows = [
  {
    date: '06/24/2026',
    description: 'Route document: Labor created by: Medical Doctor MD'
  },
  {
    date: '06/24/2026',
    description: 'Signed SOAP Note: Headache Signed by: Doctor MD'
  },
  {
    date: '06/24/2026',
    description: 'Route document: Labor created by: Medical Doctor MD'
  },
  {
    date: '06/24/2026',
    description: 'Signed SOAP Note: Headache Signed by: Doctor MD'
  },
  {
    date: '06/24/2026',
    description: 'Route document: Labor created by: Medical Doctor MD'
  },
  {
    date: '06/24/2026',
    description: 'Signed SOAP Note: Headache Signed by: Doctor MD'
  },
  {
    date: '06/24/2026',
    description: 'Route document: Labor created by: Medical Doctor MD'
  },
  {
    date: '06/24/2026',
    description: 'Route document: Labor created by: Medical Doctor MD'
  },
  {
    date: '06/24/2026',
    description: 'Signed SOAP Note: Headache Signed by: Doctor MD'
  },
  {
    date: '06/24/2026',
    description: 'Route document: Labor created by: Medical Doctor MD'
  },
  {
    date: '06/24/2026',
    description: 'Signed SOAP Note: Headache Signed by: Doctor MD'
  },
  {
    date: '06/24/2026',
    description: 'Route document: Labor created by: Medical Doctor MD'
  },
  {
    date: '06/24/2026',
    description: 'Route document: Labor created by: Medical Doctor MD'
  },
  {
    date: '06/24/2026',
    description: 'Signed SOAP Note: Headache Signed by: Doctor MD'
  },
  {
    date: '06/24/2026',
    description: 'Route document: Labor created by: Medical Doctor MD'
  },
  {
    date: '06/24/2026',
    description: 'Signed SOAP Note: Headache Signed by: Doctor MD'
  },
  {
    date: '06/24/2026',
    description: 'Route document: Labor created by: Medical Doctor MD'
  },
  {
    date: '06/24/2026',
    description: 'Route document: Labor created by: Medical Doctor MD'
  },
  {
    date: '06/24/2026',
    description: 'Signed SOAP Note: Headache Signed by: Doctor MD'
  },
  {
    date: '06/24/2026',
    description: 'Route document: Labor created by: Medical Doctor MD'
  },
  {
    date: '06/24/2026',
    description: 'Signed SOAP Note: Headache Signed by: Doctor MD'
  },
  {
    date: '06/24/2026',
    description: 'Route document: Labor created by: Medical Doctor MD'
  }
];

const DataHx = ({ className }) => {
  return (
    <Box
      className={className}
      sx={dataHxContainerSx}>
      <Table sx={dataHxTableSx}>
        <TableBody>
          {recapRows.map((row, index) => (
            <TableRow
              key={index}
              sx={dataHxRowSx}>
              <TableCell sx={dataHxDateCellSx}>
                {row.date}
              </TableCell>

              <TableCell>
                {row.description}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Box>
  );
};

DataHx.propTypes = {
  className: PropTypes.string
};

export default DataHx;